import "./Spinner.scss";

export const Spinner = () => (
  <svg viewBox="0 0 250 248.07" className="spinnerIcon">
    <defs>
      <linearGradient id="Sfumatura_senza_nome_30" x1="2.53" y1="123.73" x2="250" y2="123.73" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#4b78c6" />
        <stop offset="1" stopColor="#2b4281" />
      </linearGradient>
      <linearGradient id="Sfumatura_senza_nome_14" x1="0" y1="128.09" x2="239.97" y2="128.09" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#95d0e5" />
        <stop offset="1" stopColor="#009ee3" />
      </linearGradient>
    </defs>
    <g>
      <circle className="cls-4" cx="126.27" cy="123.73" r="123.73" />
      <circle className="cls-3" cx="119.99" cy="128.09" r="119.99" />
      <g>
        <g className="cls-2">
          <path
            className="cls-1"
            d="M155.49,90.05c-3.49,0-6.19.69-8.12,2.07-1.93,1.38-2.89,3.45-2.89,6.21,0,2.54,1.4,4.78,4.19,6.7,2.79,1.93,6.52,3.76,11.17,5.5,3.77,1.38,7.01,2.96,9.69,4.74,2.69,1.78,4.92,4.23,6.7,7.35,1.78,3.12,2.67,7.08,2.67,11.87,0,4.14-1.07,7.97-3.21,11.49-2.14,3.52-5.28,6.32-9.42,8.39-4.14,2.07-9.08,3.1-14.81,3.1-4.79,0-9.55-.71-14.27-2.12-4.72-1.42-9.11-3.58-13.18-6.48l6.97-12.31c2.76,2.03,5.92,3.7,9.48,5.01,3.56,1.31,6.75,1.96,9.59,1.96,3.34,0,6.24-.71,8.72-2.12,2.47-1.42,3.7-3.72,3.7-6.92,0-4.14-3.89-7.73-11.66-10.78-4.58-1.81-8.39-3.56-11.44-5.23-3.05-1.67-5.68-4.07-7.9-7.19-2.22-3.12-3.32-7.04-3.32-11.76,0-6.9,2.27-12.45,6.81-16.67,4.54-4.21,10.58-6.5,18.14-6.86,5.95,0,10.93.67,14.92,2.01,3.99,1.34,7.88,3.25,11.66,5.72l-5.99,12.09c-6.97-3.85-13.04-5.77-18.19-5.77Z"
          />
        </g>
        <g className="cls-2">
          <path
            className="cls-1"
            d="M107.39,83.64c5.38,4.83,8.07,11.43,8.07,19.78,0,4.79-.93,9.28-2.78,13.46-1.85,4.18-4.87,7.61-9.05,10.3-4.18,2.69-9.57,4.03-16.19,4.03h-11.34v25.4h-15.8v-80.22h24.31c9.81,0,17.4,2.42,22.78,7.25ZM94.53,113.83c1.82-1.34,3.12-2.92,3.92-4.74.8-1.82,1.2-3.56,1.2-5.23,0-2.83-.84-5.57-2.51-8.23-1.67-2.65-4.9-3.98-9.7-3.98h-11.34v24.2h11.23c2.98,0,5.38-.67,7.19-2.02Z"
          />
        </g>
      </g>
      <g className="cls-2">
        <g className="cls-2">
          <path className="cls-1" d="M77.33,166.94v4.28h-7.18v23.53h-4.43v-23.53h-6.99v-4.28h18.6Z" />
          <path
            className="cls-1"
            d="M85.47,180c.79-.69,1.6-1.22,2.43-1.58.83-.37,1.52-.55,2.08-.55l-.19,4.28c-1.17-.1-2.21.11-3.13.63-.92.52-1.63,1.24-2.14,2.14-.51.9-.76,1.87-.76,2.88v6.95h-4.28v-16.16h3.86l.31,3.74c.43-.87,1.04-1.64,1.83-2.33Z"
          />
          <path
            className="cls-1"
            d="M110.48,178.59v16.16h-4.28v-2.33c-.59.69-1.38,1.32-2.37,1.89-.99.57-2.15.86-3.48.86-1.55,0-2.94-.32-4.16-.97s-2.19-1.61-2.9-2.88c-.71-1.27-1.07-2.81-1.07-4.62s.37-3.3,1.11-4.64c.74-1.34,1.72-2.37,2.96-3.09,1.23-.73,2.59-1.09,4.07-1.09,2.62,0,4.58.97,5.88,2.9l.31-2.18h3.93ZM104.51,190.75c.8-.6,1.37-1.44,1.7-2.54v-3.51c-.31-.99-.9-1.79-1.78-2.41-.88-.61-1.89-.92-3.04-.92-1.35,0-2.5.48-3.44,1.43-.94.95-1.41,2.17-1.41,3.65,0,.97.23,1.85.69,2.64.46.79,1.07,1.41,1.83,1.87.76.46,1.59.69,2.48.69,1.17,0,2.16-.3,2.96-.9Z"
          />
          <path
            className="cls-1"
            d="M126.81,194.65c-1.03.34-2.07.52-3.11.52-1.78,0-3.35-.34-4.72-1.03-1.36-.69-2.41-1.67-3.15-2.96-.74-1.29-1.11-2.79-1.11-4.53s.39-3.2,1.18-4.49c.79-1.29,1.84-2.27,3.15-2.96,1.31-.69,2.72-1.03,4.22-1.03,2.55,0,4.65.69,6.3,2.06l-2.14,2.79c-.48-.38-1.05-.71-1.7-.97-.65-.27-1.34-.4-2.08-.4-1.3,0-2.4.48-3.3,1.43-.9.96-1.36,2.15-1.36,3.57s.48,2.62,1.43,3.57c.95.95,2.17,1.43,3.65,1.43,1.27,0,2.34-.36,3.21-1.07l2.14,2.67c-.71.59-1.58,1.05-2.62,1.39Z"
          />
          <path
            className="cls-1"
            d="M139.62,187.41l-1.87,1.45v5.88h-4.28v-29.79h4.28v19.48l8.1-6.23,2.6,2.29-5.88,4.58,6.57,9.66h-4.96l-4.54-7.33Z"
          />
          <path
            className="cls-1"
            d="M163.84,190.23l1.95,3.17c-.87.54-1.79.96-2.79,1.28-.99.32-1.95.48-2.86.48-1.86,0-3.47-.37-4.83-1.11-1.36-.74-2.41-1.76-3.13-3.06-.73-1.3-1.09-2.79-1.09-4.47,0-1.58.41-3.03,1.22-4.35.81-1.32,1.92-2.37,3.32-3.15,1.4-.78,2.93-1.17,4.58-1.17,2.19,0,4.01.64,5.46,1.93,1.45,1.29,2.42,3.1,2.9,5.44l-12.45,4.2c.43.66,1.01,1.17,1.72,1.53.71.36,1.5.54,2.37.54,1.2,0,2.41-.42,3.63-1.26ZM156.56,182.64c-.85.94-1.28,2.16-1.28,3.67,0,.28.01.5.04.65l8.48-3.02c-.33-.79-.81-1.44-1.45-1.95-.64-.51-1.46-.76-2.48-.76-1.35,0-2.45.47-3.3,1.41Z"
          />
          <path
            className="cls-1"
            d="M178.43,180c.79-.69,1.6-1.22,2.43-1.58.83-.37,1.52-.55,2.08-.55l-.19,4.28c-1.17-.1-2.21.11-3.13.63-.92.52-1.63,1.24-2.14,2.14-.51.9-.76,1.87-.76,2.88v6.95h-4.28v-16.16h3.86l.31,3.74c.43-.87,1.04-1.64,1.83-2.33Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
